import { cn } from '@eureca/ui';

export function GoogleIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('size-4 text-primary lg:size-5', className)}
      aria-hidden
      {...props}
    >
      <path d="M20.3 12.2a8.3 8.3 0 1 1-2.9-6.6" />
      <path d="M12 12h8.5" />
    </svg>
  );
}
